var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('WeWidget',{attrs:{"cards":"1","choropleth":"1","cart-average":"1","product":"1","category-product":"1"}}),_c('WeFailedOrderBadge')],1)}
var staticRenderFns = []

export { render, staticRenderFns }